/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const DROPIN_GAME_INFO = graphql(`
  query dropinGameInfo($gameId: uuid!, $userId: uuid!) {
    games_by_pk(_id: $gameId) {
      _id
      start_time
      end_time
      drop_in_slots(where: { registrants: { user: { _eq: $userId } } }) {
        _id
      }
    }
  }
`);
